






















































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';
import { BOTTLE_150 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { sendGaEvent as sendEvent } from '~/utils/ga';
import { StaffReview } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppAvatar,
    AppOptimizedImage,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<StaffReview>,
      required: true,
    },
  },
  setup(props) {
    const sendGaEvent = () => {
      sendEvent(
        '新着スタッフレビュー',
        url('STAFF_REVIEW_DETAIL', { id: props.item.id }),
        `${props.item.shop.name}/${props.item.user.name}`
      );
    };

    return {
      sendGaEvent,
      url,
      BOTTLE_150,
    };
  },
});
